import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const MainPageNamesThunk = createAsyncThunk(
	'MainPageNamesThunk',
	async (_, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const res = await axios.get(
				'https://api.act2hf.com/api/public/main_page_names',
			);

			return res?.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	},
);
